import { PropsWithChildren } from "react";

import { Box, BoxProps, Heading, HStack, Text } from "@chakra-ui/react";

type SectionProps = {
  heading?: string | React.ReactNode;
  headingRightElement?: React.ReactNode;
  subheading?: string;
};

export default function Section({
  heading,
  subheading,
  headingRightElement,
  children,
  ...boxProps
}: PropsWithChildren<SectionProps> & BoxProps) {
  const headingElement = heading && (
    <Heading as="h5" size="sm" w="full">
      {heading}
    </Heading>
  );
  const stackedHeadingElement = headingRightElement ? (
    <HStack justifyContent="space-between">
      {headingElement}
      {headingRightElement}
    </HStack>
  ) : (
    headingElement
  );

  return (
    <Box as="section" {...boxProps}>
      <Box mb={4}>
        {stackedHeadingElement}
        <Text textStyle="subheading">{subheading}</Text>
      </Box>
      {children}
    </Box>
  );
}
